__turbopack_context__.v({
  "moneyBlocksWrapper": "MoneyBlocks-module-scss-module__HXziCW__moneyBlocksWrapper",
});
